import React from 'react';
import { EditorialSelect } from '../common/editorial/EditorialControls';

const CommunityFilters = ({
  filterOptions,
  topicOptions,
  activeFilter,
  selectedTopic,
  onFilterChange,
  onTopicChange,
}) => (
  <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
    <div className="flex flex-wrap items-center gap-2">
      {filterOptions.map((filter) => {
        const Icon = filter.icon;
        const active = activeFilter === filter.id;
        return (
          <button
            key={filter.id}
            type="button"
            onClick={() => onFilterChange(filter.id)}
            className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md text-label font-medium border transition-colors duration-300 ${
              active
                ? 'bg-pine-tint border-pine text-pine'
                : 'border-hairline text-secondary hover:text-primary hover:bg-pine-tint/50'
            }`}
          >
            <Icon className="w-4 h-4" />
            <span>{filter.label}</span>
          </button>
        );
      })}
    </div>

    <EditorialSelect
      value={selectedTopic}
      onChange={(e) => onTopicChange(e.target.value)}
      className="w-full sm:w-auto sm:min-w-[180px]"
    >
      {topicOptions.map((topic) => (
        <option key={topic.id} value={topic.id}>
          {topic.label}
        </option>
      ))}
    </EditorialSelect>
  </div>
);

export default CommunityFilters;
